import { Link } from "react-router-dom";
import { ArrowRight, KeyRound, Check } from "lucide-react";
import { SectionHeading } from "../common/SectionHeading";
import { Reveal } from "../common/Reveal";
import { IMAGES } from "../../lib/data";

const RETAILERS = ["Delis", "Grocery Stores", "Convenience Stores", "Specialty Stores", "Cafes", "Event Venues", "Gift Shops"];
const PERKS = ["Multiple flavors", "Retail-ready products", "Easy reordering", "Wholesale pricing", "Local NYC support"];

export const Wholesale = () => (
    <section data-testid="wholesale-section" className="relative py-24 md:py-36 overflow-hidden">
        <img
            src={IMAGES.wholesale}
            alt="Premium retail shelves"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/80" />
        <div className="relative mx-auto max-w-[1440px] px-5 md:px-10">
            <div className="max-w-2xl">
                <SectionHeading
                    chapter="07"
                    kicker="For Retailers"
                    title="Put Showtime On Your Shelves."
                    copy="Retail-ready Showtime cotton candy and popcorn — made to move off your shelf and onto the feed."
                    dark
                    testid="wholesale-heading"
                />
                <Reveal>
                    <ul className="flex flex-wrap gap-2 mb-10" data-testid="wholesale-retailer-types">
                        {RETAILERS.map((r) => (
                            <li key={r} className="rounded-full border border-zinc-600 px-4 py-2 text-xs font-bold tracking-[0.15em] uppercase text-zinc-200">
                                {r}
                            </li>
                        ))}
                    </ul>
                </Reveal>
                <Reveal delay={0.1}>
                    <ul className="grid sm:grid-cols-2 gap-3 mb-12" data-testid="wholesale-perks">
                        {PERKS.map((p) => (
                            <li key={p} className="flex items-center gap-3 text-sm text-zinc-300">
                                <Check size={16} className="text-pink shrink-0" /> {p}
                            </li>
                        ))}
                    </ul>
                </Reveal>
                <Reveal delay={0.15}>
                    <div className="flex flex-wrap items-center gap-4">
                        <Link
                            to="/wholesale"
                            data-testid="become-retailer-cta"
                            className="inline-flex items-center gap-2 rounded-full bg-pink px-8 py-4 font-oswald uppercase tracking-widest text-ink hover:bg-white transition-colors duration-300 active:scale-95"
                        >
                            Become a Retailer <ArrowRight size={16} />
                        </Link>
                        <Link
                            to="/wholesale"
                            data-testid="retailer-login-cta"
                            className="inline-flex items-center gap-2 rounded-full border-2 border-white px-8 py-4 font-oswald uppercase tracking-widest text-white hover:bg-white hover:text-ink transition-colors duration-300 active:scale-95"
                        >
                            <KeyRound size={15} /> Retailer Login
                        </Link>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
